import { createSelector } from 'reselect';

import { REDUCER_KEY } from './rootUiReducer';

export const getRootUiStore = (state) => state[REDUCER_KEY];
export const getRootUi = (state) => getRootUiStore(state);
export const getActiveModals = (state) => getRootUiStore(state).activeModals;

export const getActiveModalsAsJS = createSelector(getActiveModals, (activeModals) => activeModals.toJS());
